import React, { useContext, useEffect, useState } from "react";
import { DatePicker, Form, Tooltip } from "antd";
import axios from "axios";
import { BACKEND_URL } from "../../../config/config";
import Qs from "qs";
import locale from "antd/lib/date-picker/locale/fr_FR";
import moment from "moment";
import "moment/locale/fr";
import SearchAutocomplete from "../../misc/searchAutocomplete/SearchAutocomplete.js";
import {
  ClearOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  ExportOutlined,
  EditOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
  EuroOutlined,
  EyeOutlined,
  ClockCircleTwoTone,
  DeleteOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { NotificationContext } from "../../context/NotificationWrapper";
import { Button } from "../../misc/button/Button.js";
import TableDeclarations from "./TableDeclarations.js";
import { AuthContext } from "../../context/AuthProviderWrapper.js";
import { DeclarationContext } from "../../context/DeclarationWrapper.js";
import EditDeclarationModal from "../declarationDetail-CRUD/EditDeclarationModal.js";
import { useLocation } from "react-router-dom";
import CancelDeclarationModal from "./CancelDeclarationModal";
import RequestModificationModal from "./RequestModificationModal";
import ModificationReviewModal from "./ModificationReviewModal";
import SpinLoading from "../../misc/loading/SpinLoading";

const { RangePicker } = DatePicker;

moment.locale("fr");

const dateFormatDateMonthYear = "DD/MM/YYYY";
const dateFormatMonthYear = "MM/YYYY";

export default function DeclarationList() {
  const { user, isAdmin, userRoles } = useContext(AuthContext);
  const { isAttestation } = useContext(DeclarationContext);
  const [data, setData] = useState(null);
  const [totalItems, setTotalItems] = useState(1);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);
  const [isEditableFlag, setIsEditableFlag] = useState(false);
  const [form] = Form.useForm();
  const { state } = useLocation();
  // statuts des déclarations
  const [status, setStatus] = useState([]);
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 10,
    startMonth: state?.startMonth || null,
    endMonth: null,
    startYear: state?.startYear || null,
    endYear: null,
    user: null,
    membershipCategory: null,
    validatedDateStart: null,
    validatedDateEnd: null,
    payed: state?.payed || null,
    status: [],
    declarationType: [],
  });
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState([]);
  const [declarationType, setDeclarationType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingExcelExport, setIsLoadingExcelExport] = useState(false);
  const { openNotification } = useContext(NotificationContext);
  const [isMediumScreen, setIsMediumScreen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  // modal d'annulation
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [declarationToCancel, setDeclarationToCancel] = useState(null);

  const [requestModificationModalVisible, setRequestModificationModalVisible] = useState(false);
  const [modificationReviewModalVisible, setModificationReviewModalVisible] = useState(false);
  const [declarationToModify, setDeclarationToModify] = useState(null);
  const [modificationReason, setModificationReason] = useState("");
  

  // Function to handle screen size changes
  const handleResize = () => {
    setIsMediumScreen(window.innerWidth < 1400 && window.innerWidth > 1278);
    setIsSmallScreen(window.innerWidth < 1278);
  };

  // Attach resize event listener
  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    if (filters.status) {
      setStatus(filters.status);
    }
  }, [filters.status]);

  useEffect(() => {
    if (filters.membershipCategory) {
      setCategory(filters.membershipCategory);
    } else {
      setCategory([]);
    }
  }, [filters.membershipCategory]);


  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/api/declaration/get?`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: getQueryParams(),
        paramsSerializer: function (params_1) {
          return Qs.stringify(params_1, {
            arrayFormat: "comma",
            encode: false,
          });
        },
      });
      setIsLoading(false);
      setTotalItems(response?.data?.totalCount);
      formatData(response?.data?.items);
    } catch (error) {
      setIsLoading(false);
      openNotification("Erreur", error?.response?.data?.data, "error");
      console.error("error", error);
    }
  };

  // this function is used to form the params of the GET request
  const getQueryParams = () => {
    Object.keys(filters).forEach((key) => {
      if (filters[key] === null || typeof filters[key] === "undefined" || (Array.isArray(filters[key]) && filters[key].length === 0)) {
        delete filters[key];
      }
    });
    return filters;
  };

  const handleDownloadPdf = (element) => {
    axios
      .get(`${BACKEND_URL}/api/declaration/bill-pdf/${element.id}`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf, application/zip", // Accepter les types PDF et ZIP
        },
        responseType: "blob",
      })
      .then((response) => {
        // Extraire le nom du fichier de l'en-tête Content-Disposition
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'facture.pdf'; // Nom par défaut
        
        if (contentDisposition) {
          // Amélioration de l'extraction du nom de fichier avec support pour les guillemets
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }
        
        // Déterminer l'extension de fichier correcte à partir du type de contenu
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/zip')) {
          // Assurer que l'extension est .zip si le type de contenu est zip
          if (!filename.toLowerCase().endsWith('.zip')) {
            filename = filename.replace(/\.[^/.]+$/, "") + '.zip';
          }
        } else if (contentType && contentType.includes('application/pdf')) {
          // Assurer que l'extension est .pdf si le type de contenu est pdf
          if (!filename.toLowerCase().endsWith('.pdf')) {
            filename = filename.replace(/\.[^/.]+$/, "") + '.pdf';
          }
        }
        
        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch((error) => {
        console.error("error", error);
        // Afficher une notification d'erreur à l'utilisateur
        openNotification("Erreur de téléchargement", "Impossible de télécharger le fichier. Veuillez réessayer plus tard.", "error");
      });
  };

  const translateStatus = (status) => {
    switch(status) {
      case 'active': return 'Actif';
      case 'pending_modification': return 'Demande modification';
      case 'pending_attestation': return 'Demande attestation';
      case 'modification_approved': return 'Demande approuvée';
      case 'cancelled': return 'Annulé';
      default: return status;
    }
  };

  const formatData = (dataList) => {
    let formattedData = {};
    if (isAdmin) {
      formattedData = dataList?.map((el) => {
        // Détecter si c'est une pseudo-déclaration (demande de création)
        const isCreationRequest = typeof el.id === 'string' && el.id.startsWith('AR-');

        return {
          id: el.id,
          key: el.id,
          companyName: <div style={{ fontWeight: "bold" }}>{el.companyName}</div>,
          membershipCode: (
            <div style={{ fontWeight: "bold" }}>{el.membershipCode}</div>
          ),
          membershipCategory: (
            <div style={{ fontWeight: "bold" }}>{el.membershipCategory}</div>
          ),
          feeAmount: (
            <div style={{ fontWeight: "bold" }}>{el.feeAmountLocale}</div>
          ),
          workForce: <div>{el.workForce}</div>,
          imputedDate: el.imputedDate,
          formatedInputedDate: <div>{el.formatedInputedDate}</div>,
          formatedValidatedDate: <div>{el.formatedCreationDate}</div>,
          paymentMethod: <div>{el.paymentMethod}</div>,
          payed:
            el.payed === "yes" ? (
              <Tooltip title="Réglé">
                <CheckCircleTwoTone twoToneColor="#52c41a" />
              </Tooltip>
            ) : el.payed === "no" ? (
              <Tooltip title="Non réglé">
                <CloseCircleTwoTone twoToneColor="red" />
              </Tooltip>
            ) : el.payed === null ? (
              // Pas d'icône pour les demandes de création (pas encore de facture)
              <div>-</div>
            ) : (
              <Tooltip title="En cours de traitement">
                <ClockCircleTwoTone twoToneColor="orange" />
              </Tooltip>
            ),
          edit: (
            <div className="edit-download">
              {!isCreationRequest && (
                <>
                  <Button
                    onClick={() => handleEdit(el)}
                    classNameElement="btn-edit-download"
                    children={<EditOutlined />}
                    title="Modifier"
                  />

                  <Button
                    onClick={() => handleDownloadPdf(el)}
                    classNameElement="btn-edit-download"
                    children={<DownloadOutlined />}
                    title="Télécharger Pdf"
                  />
                </>
              )}
            </div>
          ),
          modificationActions: (
            <div className="edit-download">
              {(el.status === "pending_modification" || el.status === "pending_attestation") && (
                <Button
                  onClick={() => handleReviewModification(el)}
                  classNameElement="btn-edit-download"
                  title="Examiner la demande"
                  children={<InfoCircleOutlined />}
                />
              )}
              {el.status === "active" && userRoles.includes("ROLE_SUPER_ADMIN") && !isCreationRequest && (
                <Button
                  onClick={() => handleCancelDeclaration(el)}
                  classNameElement="btn-edit-download"
                  danger
                  title="Annuler la déclaration"
                  children={<DeleteOutlined />}
                />
              )}
            </div>
          ),
          status: <div>{translateStatus(el.status)}</div>,
          declarationType: el.declarationType,
          // Conserver les flags pour que handleReviewModification puisse détecter le type
          hasAttestationRequest: el.hasAttestationRequest,
          attestationRequestId: el.attestationRequestId,
        };
      });
    } else {
      formattedData = dataList?.map((el) => ({
        id: el.id,
        key: el.id,
        companyName: <div style={{ fontWeight: "bold" }}>{el.companyName}</div>,
        membershipCode: (
          <div style={{ fontWeight: "bold" }}>{el.membershipCode}</div>
        ),
        membershipCategory: (
          <div style={{ fontWeight: "bold" }}>{el.membershipCategory}</div>
        ),
        feeAmount: (
          <div style={{ fontWeight: "bold" }}>{el.feeAmountLocale}</div>
        ),
        workForce: <div>{el.workForce}</div>,
        imputedDate: el.imputedDate,
        formatedInputedDate: <div>{el.formatedInputedDate}</div>,
        formatedValidatedDate: <div>{el.formatedCreationDate}</div>,
        paymentMethod: <div>{el.paymentMethod}</div>,
        payed:
          el.payed === "yes" ? (
            <Tooltip title="Réglé">
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            </Tooltip>
          ) : el.payed === "no" ? (
            <Tooltip title="Non réglé">
              <CloseCircleTwoTone twoToneColor="red" />
            </Tooltip>
          ) : (
            <Tooltip title="En cours de traitement">
              <ClockCircleTwoTone twoToneColor="orange" />
            </Tooltip>
          ),
        edit: (
          <div className="edit-download">
            <Button
              onClick={() => handleEdit(el)}
              classNameElement="btn-edit-download"
              children={
                el.payed !== "no" || el.status !== 'active'
                  ? <InfoCircleOutlined />
                  : isAttestation(el)
                    ? <InfoCircleOutlined />
                    : <EuroOutlined />
              }
              title={
                el.payed !== "no" || el.status !== 'active'
                  ? "Consulter"
                  : isAttestation(el)
                    ? "Consulter"
                    : "Payer"
              }
            />
            <Button
              onClick={() => handleDownloadPdf(el)}
              classNameElement="btn-edit-download"
              children={<DownloadOutlined />}
              title="Télécharger PDF"
            />
          </div>
        ),
        modificationActions: (
          <div className="edit-download">
            {el.status === "active" && (
              <Button
                onClick={() => handleRequestModification(el)}
                classNameElement="btn-edit-download"
                title="Demander une modification"
                children={<FormOutlined />}
              />
            )}
            {el.status === "pending_modification" && (
              <Tooltip title="Demande en attente d'approbation">
                <ClockCircleTwoTone twoToneColor="orange" />
              </Tooltip>
            )}
            {el.status === "modification_approved" && (
              <Button
                onClick={() => handleEdit(el)}
                classNameElement="btn-edit-download"
                title="Modifier la déclaration"
                children={<EditOutlined />}
              />
            )}
          </div>
        ),
        status: <div>{translateStatus(el.status)}</div>,
        declarationType: el.declarationType,
      }));
    }
    setData(formattedData);
  };

  const handleRequestModification = (record) => {
    setDeclarationToModify(record);
    setRequestModificationModalVisible(true);
  };

  const submitModificationRequest = (declarationId, reason) => {
    setIsLoading(true);
    axios
      .post(`${BACKEND_URL}/api/declaration/request-modification/${declarationId}`, 
        { reason: reason },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
      .then(() => {
        openNotification(
          "Succès",
          "Votre demande de modification a été envoyée",
          "success"
        );
        // Fermer la modal et réinitialiser les états associés
        setRequestModificationModalVisible(false);
        setDeclarationToModify(null);
        fetchData();
      })
      .catch((error) => {
        openNotification(
          "Erreur",
          error.response?.data?.data || "Une erreur est survenue",
          "error"
        );
        console.error("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleReviewModification = (record) => {
    setIsLoading(true);

    // Détecter s'il s'agit d'une demande d'attestation ou d'une modification classique
    const isAttestationRequest = record.hasAttestationRequest;
    const apiUrl = isAttestationRequest
      ? `${BACKEND_URL}/api/attestation-request/${record.attestationRequestId}`
      : `${BACKEND_URL}/api/declaration/modification-details/${record.id}`;

    axios
      .get(apiUrl, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        const data = response.data.data;

        if (isAttestationRequest) {
          // Pour une demande d'attestation
          setModificationReason({
            type: 'attestation',
            transitionType: data.transitionType,
            dsnFile: data.dsnFile,
            requestedAt: data.requestedAt,
            ...data
          });
        } else {
          // Pour une modification classique
          setModificationReason(data.reason || "");
        }

        setDeclarationToModify(record);
        setModificationReviewModalVisible(true);
      })
      .catch((error) => {
        openNotification(
          "Erreur",
          error.response?.data?.data || "Une erreur est survenue",
          "error"
        );
        console.error("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const handleApproveModification = async (declarationId, isAttestationRequest = false, attestationRequestId = null) => {
    setIsLoading(true);
    try {
      const apiUrl = isAttestationRequest
        ? `${BACKEND_URL}/api/attestation-request/${attestationRequestId}/approve`
        : `${BACKEND_URL}/api/declaration/approve-modification/${declarationId}`;

      const response = await axios.post(
        apiUrl,
        {},
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      openNotification(
        "Succès",
        isAttestationRequest ? "Demande d'attestation approuvée" : "Demande de modification approuvée",
        "success"
      );

      fetchData();
      return response; // Retourne la réponse pour que la promesse soit résolue
    } catch (error) {
      openNotification(
        "Erreur",
        error.response?.data?.data || "Une erreur est survenue",
        "error"
      );
      console.error("error", error);
      throw error; // Propage l'erreur pour que la promesse soit rejetée
    } finally {
      setIsLoading(false);
      setModificationReviewModalVisible(false);
    }
  };
  
  const handleRejectModification = async (declarationId, isAttestationRequest = false, attestationRequestId = null, reason = null) => {
    setIsLoading(true);
    try {
      const apiUrl = isAttestationRequest
        ? `${BACKEND_URL}/api/attestation-request/${attestationRequestId}/reject`
        : `${BACKEND_URL}/api/declaration/reject-modification/${declarationId}`;

      const body = isAttestationRequest && reason ? { reason } : {};

      const response = await axios.post(
        apiUrl,
        body,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      openNotification(
        "Succès",
        isAttestationRequest ? "Demande d'attestation rejetée" : "Demande de modification rejetée",
        "success"
      );

      fetchData();
      return response; // Retourne la réponse pour que la promesse soit résolue
    } catch (error) {
      openNotification(
        "Erreur",
        error.response?.data?.data || "Une erreur est survenue",
        "error"
      );
      console.error("error", error);
      throw error; // Propage l'erreur pour que la promesse soit rejetée
    } finally {
      setIsLoading(false);
      setModificationReviewModalVisible(false);
    }
  };

  const handleCancelDeclaration = (record) => {
    setDeclarationToCancel(record);
    setCancelModalVisible(true);
  };

  const confirmCancelDeclaration = (declarationId, reason) => {
    setIsLoading(true);
    axios
      .post(`${BACKEND_URL}/api/declaration/cancel`, 
        { id: declarationId, reason:reason },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then(() => {
        openNotification(
          "Succès",
          "La déclaration a été annulée",
          "success"
        );
        setCancelModalVisible(false);
        fetchData();
      })
      .catch((error) => {
        openNotification(
          "Erreur",
          error.response?.data?.data || "Une erreur est survenue",
          "error"
        );
        console.error("error", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleTableChange = (e, value) => {
    setStatus(value.status || []);
    setCategory(value.membershipCategory || []);
    setDeclarationType(value.declarationType || []);
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: e.current,
      pageSize: e.pageSize,
      startMonth: filters.startMonth,
      endMonth: filters.endMonth,
      startYear: filters.startYear,
      endYear: filters.endYear,
      user: filters.user,
      membershipCategory: value.membershipCategory,
      status: value.status || [],
      declarationType: value.declarationType || [],
    }));
  };

  /// fix user id is company id
  const checkIfEditable = (declaration) => {
    if (isAdmin) {
      // L'administrateur ne peut plus éditer les déclarations
      return false;
    } else {
      // Le client peut éditer si la demande a été approuvée
      return declaration?.status === "modification_approved";
    }
  };
  

  // open modal and set data inside
  const handleEdit = (record) => {
    const flag = checkIfEditable(record);
    setIsEditableFlag(flag);
    setEditedRecord(record);
    setEditModalVisible(true);
  };

  const handleResetFilters = () => {
    setFilters({
      page: 1,
      startMonth: null,
      endMonth: null,
      startYear: null,
      endYear: null,
      user: null,
      bill: null,
      membershipCategory: null,
      validatedDateStart: null,
      validatedDateEnd: null,
      status: [],
      declarationType: [],
    });
    setCategory([]);
    setStatus([]);
    setDeclarationType([]);
    setSearchValue("");
  };

  // on OK on the MONTH + YEAR rangepicker
  const handleSendMonthRequest = () => {
    form.validateFields().then((values) => {
      // Accédez aux valeurs du champ RangePicker
      const dateRangeValues = values["monthRange"];

      // Vérifiez si les valeurs sont null ou non
      if (!dateRangeValues || !dateRangeValues[0] || !dateRangeValues[1]) {
        return setFilters({
          ...filters,
          page: 1,
          startMonth: null,
          startYear: null,
          endMonth: null,
          endYear: null,
        });
      } else {
        return setFilters({
          ...filters,
          page: 1,
          startMonth: dateRangeValues[0].month() + 1,
          startYear: dateRangeValues[0].year(),
          endMonth: dateRangeValues[1].month() + 1,
          endYear: dateRangeValues[1].year(),
        });
      }
    });
  };

  // on OK on the DAY MONTH & YEAR rangepicker
  const handleSendvalidatedDateRequest = () => {
    form.validateFields().then((values) => {
      const dateRangeValues = values["dateRange"];

      if (!dateRangeValues || !dateRangeValues[0] || !dateRangeValues[1]) {
        return setFilters({
          ...filters,
          page: 1,
          validatedDateStart: null,
          validatedDateEnd: null,
        });
      } else {
        const startDateString = dateRangeValues[0].format("DD/MM/YYYY");
        const endDateString = dateRangeValues[1].format("DD/MM/YYYY");
        return setFilters({
          ...filters,
          page: 1,
          validatedDateStart: startDateString,
          validatedDateEnd: endDateString,
        });
      }
    });
  };

  const handleEditModalCancel = () => {
    setEditModalVisible(false);
    fetchData();
    setIsEditableFlag(false);
  };

  const handleUserSearch = (selectedOption) => {
    const newFilters = {
      ...filters,
      page: 1,
      startMonth: filters.startMonth,
      endMonth: filters.endMonth,
      startYear: filters.startYear,
      endYear: filters.endYear,
      membershipCategory: filters.membershipCategory,
    };

    // Vérifier le type de sélection
    if (selectedOption && ['bill', 'creditNote', 'attestation'].includes(selectedOption.type)) {
      // Document sélectionné
      newFilters.bill = selectedOption.value;
      newFilters.user = null;
    } else if (selectedOption) {
      // Company ou User sélectionné
      newFilters.user = selectedOption.value;
      newFilters.bill = null;
    } else {
      // Reset
      newFilters.user = null;
      newFilters.bill = null;
    }

    setFilters(newFilters);
  };

  const handleUserChange = (e) => {
    setSearchValue(e);
  };

  const handleExportExcel = () => {
    setIsLoadingExcelExport(true);
    openNotification(
      "Export CSV",
      "Votre téléchargement a débuté en arrière plan. Cela peut prendre un peu de temps.",
      "info"
    );
    axios
      .get(`${BACKEND_URL}/api/export/excel?`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        params: getQueryParams(),
        paramsSerializer: function (params) {
          return Qs.stringify(params, { arrayFormat: "comma", encode: false });
        },
        responseType: "blob",
      })
      .then((response) => {
        const href = URL.createObjectURL(response?.data);
        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        const date = new Date();
        link.setAttribute(
          "download",
          `declarations_${date.getDate()}_${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}_${date.getUTCFullYear()}.csv`
        );
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch((error) => {
        console.error("error", error);
      })
      .finally(() => {
        setIsLoadingExcelExport(false);
      });
  };

  return (
    <div className="block-right">
      <div className="info-table">
        <div className="input-container">
          <div className="findUser-container">
            <SearchAutocomplete
              entity="user"
              name="company"
              defaultValue={null}
              style={{ width: "300px" }}
              onValidate={handleUserSearch}
              handleChange={handleUserChange}
              value={searchValue}
              placeholder={isAdmin ? "adhérent, email, N° document, SIREN" : "Chercher n° document, Adhérent, SIREN"}
            />
          </div>
          <Form form={form}>
            <div className="findByDate-container">
              <Form.Item name="monthRange">
                <RangePicker
                  picker="month"
                  locale={locale}
                  format={dateFormatMonthYear}
                  placeholder={["date de début", "date de fin"]}
                  style={{ width: isMediumScreen ? "230px" : "auto" }}
                  onCalendarChange={handleSendMonthRequest}
                />
              </Form.Item>
            </div>
          </Form>

          {isAdmin && (
            <Form form={form}>
              <div className="findByDate-container">
                <Form.Item name="dateRange">
                  <RangePicker
                    getPopupContainer={(node) => node.parentNode}
                    locale={locale}
                    format={dateFormatDateMonthYear}
                    placeholder={["date valid. début", "date valid. fin"]}
                    style={{ width: isMediumScreen ? "230px" : "auto" }}
                    onCalendarChange={handleSendvalidatedDateRequest}
                  />
                </Form.Item>
              </div>
            </Form>
          )}

            <div
              style={{
                display: "flex",
                gap: isMediumScreen || isSmallScreen ? "35px" : "25px",
              }}
              >
              <Button
                onClick={handleResetFilters}
                children={<ClearOutlined />}
                title="Réinitialiser"
                />
            {isAdmin && (
              <Button
                onClick={handleExportExcel}
                children={isLoadingExcelExport ? <SpinLoading width={40} /> : <ExportOutlined />}
                title={isSmallScreen ? "" : "Exporter au format CSV"}
                isDisabled={isLoadingExcelExport}
                style={{width: 40}}
              />
            )}
            </div>
        </div>

        <div>
          <TableDeclarations
            category={category}
            handleTableChange={handleTableChange}
            data={data}
            filters={filters}
            totalItems={totalItems}
            isLoading={isLoading}
            status={status}
            declarationType={declarationType}
          />
        </div>
      </div>

      <EditDeclarationModal
        open={editModalVisible}
        onCancel={handleEditModalCancel}
        record={editedRecord}
        mode={isEditableFlag ? "edit" : "view"}
        navigateTo="/declaration-summary"
        isAnnual={editedRecord?.declarationType === 'annual'}
        isSemiAnnual={editedRecord?.declarationType === 'semi_annual_s1' || editedRecord?.declarationType === 'semi_annual_s2'}
        semester={editedRecord?.semester}
      />
      <CancelDeclarationModal
        visible={cancelModalVisible}
        onCancel={() => setCancelModalVisible(false)}
        onConfirm={confirmCancelDeclaration}
        record={declarationToCancel}
      />
    <RequestModificationModal
      visible={requestModificationModalVisible}
      onCancel={() => setRequestModificationModalVisible(false)}
      onConfirm={submitModificationRequest}
      record={declarationToModify}
    />

    <ModificationReviewModal
      visible={modificationReviewModalVisible}
      onCancel={() => setModificationReviewModalVisible(false)}
      onApprove={handleApproveModification}
      onReject={handleRejectModification}
      record={declarationToModify}
      reason={modificationReason}
    />
    </div>
  );
}
